import { Action } from 'redux';
import type { TaxListDetailReport } from 'model/TaxListReport';

export const TAX_LIST_DETAIL_REPORT_GET_START = 'TAX_LIST_DETAIL_REPORT_GET_START';
export const TAX_LIST_DETAIL_REPORT_GET_SUCCESS = 'TAX_LIST_DETAIL_REPORT_GET_SUCCESS';
export const TAX_LIST_DETAIL_REPORT_GET_ERROR = 'TAX_LIST_DETAIL_REPORT_GET_ERROR';

type TaxListDetailReportGetStartAction = Action<typeof TAX_LIST_DETAIL_REPORT_GET_START>;

interface TaxListDetailReportGetSuccessAction extends Action<typeof TAX_LIST_DETAIL_REPORT_GET_SUCCESS> {
    payload: { report: TaxListDetailReport };
}

type TaxListDetailReportErrorAction = Action<typeof TAX_LIST_DETAIL_REPORT_GET_ERROR>;

export type TaxListDetailReportAction =
    | TaxListDetailReportGetStartAction
    | TaxListDetailReportGetSuccessAction
    | TaxListDetailReportErrorAction;
